import { AbsoluteCenter, Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { size } from 'lodash';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import useIsLandScapeMachine from '@/hook/useIsLandScapeMachine';

import { COMMON_WEB_PATH } from '../../constant';
import Fireworks from '../NewYearDecorations/components/Fireworks';

const leftMenu = [
  {
    label: 'SLOT',
    link: '/slots'
  },
  {
    label: 'LIVE',
    link: '/live-casino'
  }
  // {
  //   label: "BINGO",
  //   link: "/bingo",
  // },
];

const rightMenu = [
  {
    label: 'FH',
    link: '/fish'
  },
  {
    label: 'TABLE',
    link: '/table'
  },
  {
    label: 'BLOCKCHAIN',
    link: '/block-chain'
  }
];

const MachineFooter = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const isLandscapeMachine = useIsLandScapeMachine();

  return (
    <Box
      position="fixed"
      bottom={isLandscapeMachine ? '70px' : '-15px'}
      left="0"
      w="100%"
      h="200px"
      zIndex="999"
      display="flex"
    >
      <AbsoluteCenter
        w={'100%'}
        h={`calc(100% + ${isLandscapeMachine ? '70px' : '0px'})`}
        top={`calc(50% + ${isLandscapeMachine ? '70px' : '0px'})`}
        pointerEvents={'none'}
        bgImage="linear-gradient(to top, rgba(41, 117, 155,1), rgba(41, 117, 155,0.9),rgba(41, 117, 155,0))"
      />
      <Fireworks sx={{ left: '-10rem', bottom: '-10rem' }} />
      <AbsoluteCenter
        bgImage={`url(${COMMON_WEB_PATH}/blue-layout/footer/footer_menu_circle.png)`}
        bgSize={{
          md: '145% 100%',
          xl: '97% 100%'
        }}
        bgRepeat={'no-repeat'}
        bgPos={{
          md: isLandscapeMachine ? '51%,center' : '54%,center',
          xl: 'center'
        }}
        w="100%"
        h="143%"
        zIndex={-1}
        left="49.5%"
        top="9%"
        pointerEvents={'none'}
      ></AbsoluteCenter>
      <Grid pb="4em" pl="50px" w="40%" templateColumns={`repeat(2, 1fr)`}>
        {leftMenu.map((item, idx) => {
          return (
            <GridItem
              role="group"
              alignItems={'center'}
              justifyContent={'flex-end'}
              display="flex"
              flexDirection={'column'}
              gap="10px"
              position="relative"
              cursor="pointer"
              as={NavLink}
              to={item.link}
            >
              {({ isActive }) => (
                <AbsoluteCenter
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  top={(idx + 1) * 3 + 'em'}
                >
                  <Box
                    w="9em"
                    h="7em"
                    bgRepeat={'no-repeat'}
                    bgPosition="center"
                    bgImage={`url(${COMMON_WEB_PATH}/blue-layout/footer/${item.label}${isActive ? '_active' : ''}.png)`}
                    bgSize="100%126%"
                    transition={'transform 0.3s ease-in-out'}
                    _groupHover={{
                      bgImage: `url(${COMMON_WEB_PATH}/blue-layout/footer/${item.label}_active.png)`,
                      transform: 'scale(1.1)'
                    }}
                  />
                  <Text
                    fontWeight={'400'}
                    fontSize="24px"
                    textShadow={'0 0 1.5px white'}
                  >
                    {i18n(item.label)}
                  </Text>
                </AbsoluteCenter>
              )}
            </GridItem>
          );
        })}
      </Grid>
      <Box w="20%" position="relative">
        <AbsoluteCenter
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          role="group"
          as={NavLink}
          to={'/'}
          top="50%"
        >
          <Box
            w="10.5em"
            h="8.5em"
            bgRepeat={'no-repeat'}
            bgPosition="center"
            bgImage={`url(${COMMON_WEB_PATH}/blue-layout/footer/LOBBY.png)`}
            transition={'transform 0.3s ease-in-out'}
            _groupHover={{
              bgImage: `url(${COMMON_WEB_PATH}/blue-layout/footer/LOBBY_active.png)`,
              transform: 'scale(1.1)'
            }}
            bgSize="100%126%"
            position="relative"
          ></Box>
          <Text
            fontWeight={'400'}
            fontSize="24px"
            textShadow={'0 0 1.5px white'}
          >
            {i18n('Home')}
          </Text>
        </AbsoluteCenter>
      </Box>
      <Grid pb="3em" pr="50px" w="40%" templateColumns={`repeat(3, 1fr)`}>
        {rightMenu.map((item, idx) => {
          return (
            <GridItem
              role="group"
              alignItems={'center'}
              justifyContent={'flex-end'}
              display="flex"
              flexDirection={'column'}
              gap="10px"
              position="relative"
              cursor="pointer"
              as={NavLink}
              to={item.link}
            >
              {({ isActive }) => (
                <AbsoluteCenter
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  top={(size(rightMenu) - idx) * 2 + 'em'}
                >
                  <Box
                    w="9em"
                    h="7em"
                    bgRepeat={'no-repeat'}
                    bgPosition="center"
                    bgImage={`url(${COMMON_WEB_PATH}/blue-layout/footer/${item.label}${isActive ? '_active' : ''}.png)`}
                    bgSize="100%126%"
                    transition={'transform 0.3s ease-in-out'}
                    _groupHover={{
                      bgImage: `url(${COMMON_WEB_PATH}/blue-layout/footer/${item.label}_active.png)`,
                      transform: 'scale(1.1)'
                    }}
                  />
                  <Text
                    fontWeight={'400'}
                    fontSize="24px"
                    textShadow={'0 0 1.5px white'}
                  >
                    {i18n(item.label)}
                  </Text>
                </AbsoluteCenter>
              )}
            </GridItem>
          );
        })}
      </Grid>
    </Box>
  );
};

export default MachineFooter;
